import {
  Layers, Package, DoorOpen, Square, Wrench, Paintbrush, Box,
  type LucideIcon,
} from 'lucide-react';
import { Badge } from '@/components/ui/Badge';
import { INVENTORY_KIND_LABELS, type InventoryKind } from '@/types/inventory';

export const KIND_ICONS: Record<InventoryKind, LucideIcon> = {
  veneer:    Layers,
  substrate: Square,
  door:      DoorOpen,
  panel:     Package,
  hardware:  Wrench,
  finish:    Paintbrush,
  other:     Box,
};

const KIND_TONES: Record<InventoryKind, 'brass' | 'info' | 'neutral' | 'warning' | 'success'> = {
  veneer:    'brass',
  substrate: 'neutral',
  door:      'info',
  panel:     'info',
  hardware:  'neutral',
  finish:    'warning',
  other:     'neutral',
};

export function KindBadge({ kind }: { kind: InventoryKind }) {
  return <Badge tone={KIND_TONES[kind]}>{INVENTORY_KIND_LABELS[kind]}</Badge>;
}

export function KindIcon({ kind, size = 16, className }: { kind: InventoryKind; size?: number; className?: string }) {
  const Icon = KIND_ICONS[kind];
  return <Icon size={size} className={className} />;
}
